import React from "react";

function HeadingAndTextComponent({
  headingText = "",
  contentText = "",
  style = {},
}) {
  return (
    <div style={{ ...style }}>
      <div className="textHeading">{headingText}</div>
      <div className="textWord mt-2">{contentText}</div>
    </div>
  );
}

export default HeadingAndTextComponent;
